import { render, staticRenderFns } from "./TransferTransactions.vue?vue&type=template&id=2fb2f691&scoped=true"
import script from "./TransferTransactions.vue?vue&type=script&lang=js"
export * from "./TransferTransactions.vue?vue&type=script&lang=js"
import style0 from "./TransferTransactions.vue?vue&type=style&index=0&id=2fb2f691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2f691",
  null
  
)

export default component.exports